const MENU_CURATION_TASK_NO_ERROR_TAG_FILTER = {
  value: 'NO_ERROR_TAG',
  label: 'No error tags',
}

module.exports = MENU_CURATION_TASK_NO_ERROR_TAG_FILTER
